import React, { useState, useEffect } from "react";
import { HeaderPaciente } from "../HeaderPaciente/index";
import { MenuLateral } from "../MenuLateral/index";
import { useSelector } from "react-redux";
import { ContenedorPaciente } from "./styles";
import { TabMenu } from "../TabMenu/index";
import { Header } from "../Header/index";
import { isMembresiaSuspendida } from "../../helpers/membresia.js";
import MembresiaPage from "../../pages/Membresia";
import styled from "styled-components";

import { PatientQuickNav } from "../PatientQuickNav/index";

const TopBar = styled.div`
  background: rgb(12, 141, 227);
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between; /* Changed */
  align-items: center;
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
`;

const HamburgerButton = styled.button`
  background: #0c8de3;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 24px;
  line-height: 1;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  z-index: 1300;
`;

const MainContent = styled.div`
  width: 100%;
  transition: padding-left 0.3s ease-in-out, padding-bottom 0.3s ease-in-out;
  padding-top: 60px; /* Add padding to account for fixed TopBar */
  padding-bottom: ${({ hasNav }) => (hasNav ? '65px' : '0')}; /* Space for BottomNav on mobile */

  @media (min-width: 769px) {
    padding-left: ${({ isOpen }) => (isOpen ? '250px' : '0')};
    padding-bottom: 0;
  }
  @media (max-width: 768px) {
    padding-left: 0;
    padding-top: 0;
  }
`;

export function LayoutPaciente({ url, children }) {
  const sesion = useSelector((state) => state.sesion); // Added
  const empresa = useSelector((state) => state.empresa);
  const isSuspendido = isMembresiaSuspendida(empresa);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  const [isMenuOpen, setMenuOpen] = useState(!isMobile);
  const hasPatient = !!sesion.paciente; // Added

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 769;
      setIsMobile(mobile);
      if (!mobile) setMenuOpen(true);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeResizeEventListener ? window.removeResizeEventListener('resize', handleResize) : window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <React.Fragment>
      <TopBar>
        <HamburgerButton onClick={() => setMenuOpen(!isMenuOpen)}>
          &#9776;
        </HamburgerButton>
        <Header />
      </TopBar>
      <TabMenu url={url} urlBase="paciente" />

      <ContenedorPaciente>
        <MenuLateral isOpen={isMenuOpen} onClose={() => setMenuOpen(false)} isMobile={isMobile} />

        <MainContent isOpen={isMenuOpen} hasNav={hasPatient && isMobile}>
          <HeaderPaciente />
          {hasPatient && <PatientQuickNav />}
          {isSuspendido ? <MembresiaPage /> : children}
        </MainContent>
      </ContenedorPaciente>
    </React.Fragment>
  );
}
